import type { FunctionComponent } from 'react'

import {
	Collapse,
	COLORS,
	CurrencyDisplay,
	InfoTooltip,
	useIntlConfig,
} from '@monthio/react-components'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { ExpandIcon } from '../../../../modulesTemp/shared/ExpandIcon'
import { budgetEstimatesCalculatorService } from './budgetEstimatesCalculatorService'
import {
	AmountAndExpandIconContainer,
	BudgetSectionHeader,
	BudgetSectionTitle,
} from './styledBudgetEstimates'

export const AggregateSectionContainer = styled.div`
	display: flex;
	flex-direction: column;
	background-color: transparent;
	justify-content: space-between;
	border-top: 1px solid ${COLORS.GREY_SCALE.LIGHT_GREY};
`

export const AggregateSectionHeaderText = styled(BudgetSectionTitle)`
	font-weight: 400;
`

export const AggregateSectionHeaderAmount = styled(AggregateSectionHeaderText)`
	color: ${COLORS.TEXT_COLORS.DEFAULT};
`

export const BudgetCategoryOverview: FunctionComponent<{
	hideHeader?: boolean
	itemKey: string
	dotKey: string
	currentKey: string
	total: number
}> = ({ children, hideHeader, itemKey, total, currentKey, dotKey }) => {
	const [expanded, setExpanded] = useState(false)
	const { t } = useTranslation()
	const intlConfig = useIntlConfig({ showCurrency: true })

	const [updatedTotal, setUpdatedTotal] = useState<number>(total)
	useEffect(() => {
		const unsubscribe = budgetEstimatesCalculatorService.subscribe((key) => {
			if (key === `${dotKey}.total`) {
				setUpdatedTotal(budgetEstimatesCalculatorService.getValue(key))
			}
		})

		return unsubscribe
	}, [])

	if (currentKey === 'total') {
		return null
	}

	itemKey = itemKey.replace('tree.', '')

	return (
		<AggregateSectionContainer>
			{!hideHeader && (
				<BudgetSectionHeader onClick={() => setExpanded(!expanded)}>
					<InfoTooltip
						tooltip={t(`${itemKey}-tooltip`)}
						modalTitle={t(`${itemKey}-modalTitle`)}
						variant="blueHelper"
					>
						<AggregateSectionHeaderText>
							{t(`${itemKey}-header`)}
						</AggregateSectionHeaderText>
					</InfoTooltip>
					<AmountAndExpandIconContainer>
						<AggregateSectionHeaderAmount>
							<CurrencyDisplay
								amount={updatedTotal}
								currencyFormatOptions={{
									intlConfig,
									allowNegativeValue: false,
								}}
							/>
						</AggregateSectionHeaderAmount>
						<ExpandIcon expanded={expanded} />
					</AmountAndExpandIconContainer>
				</BudgetSectionHeader>
			)}
			{!hideHeader ? (
				<Collapse in={expanded} timeout="auto">
					{children}
				</Collapse>
			) : (
				children
			)}
		</AggregateSectionContainer>
	)
}
